<wbo-entity-availability-edit-control [readonly]="isReadonly" [elementId]="elementId"
                                      [label]="'wbo.common.label.available'" [(ngModel)]="value">
</wbo-entity-availability-edit-control>
